module.exports = __webpack_public_path__ + "img/UI_common_framelabelBD_02_abd88a1d5.png";